import { useState, useEffect } from "react";
import { useStockPrice } from "../context/stockPrice/StockPriceContext";
import { useRuntimeConstants } from "../context/runtimeConstants/RuntimeConstantsContext";
import { getFeature } from "../utils/features";
import { useIsInStockContext } from "../context/isInStock/IsInStockContext";
import { useFeaturesReady } from "../context/featuresReady/FeaturesReadyContext";

export default function useSingleProductData(ratings) {
  const { products } = useStockPrice();
  const { product, getTranslation } = useRuntimeConstants();
  const { isInStock } = useIsInStockContext();
  const { areFeaturesReady } = useFeaturesReady();

  const [isSizingScaleEnabled, setIsSizingScaleEnabled] = useState(false);

  const subRatings = ratings?.subRatings ?? [];

  const topSubRating = subRatings.filter((rating) =>
    ["fit", "size"].includes(rating.id?.toLowerCase())
  );

  const labeledSubRatings = topSubRating.map((rating) => ({
    ...rating,
    midLabel: getTranslation("pdp_ratings_reviews_slider_size_selected_label"),
  }));

  useEffect(() => {
    if (!(areFeaturesReady && isInStock && labeledSubRatings.length)) {
      return;
    }
    setIsSizingScaleEnabled(getFeature("pdp_sizing_scale_test").isEnabled());
  }, [areFeaturesReady, isInStock, labeledSubRatings.length]);

  return {
    product,
    mainProducts: products ? [products] : [],
    labeledSubRatings,
    showSizingScale: !!isSizingScaleEnabled,
  };
}
